import React, { PropsWithChildren } from "react"

import { SpacingY } from "../SpacingY"
import PageHeader from "../PageHeader"

export interface PageLayoutProps {
  title: string
  actions?: React.ReactNode
  subtitle?: string
}

export function PageLayout(props: PropsWithChildren<PageLayoutProps>) {
  const { title, actions, children, subtitle } = props
  return (
    <SpacingY data-test-id="page-layout">
      {title && (
        <PageHeader
          title={title}
          data-test-id="page-title"
          contentOnTheRightOfTitle={
            actions && (
              <div data-test-id="page-actions-container">{actions}</div>
            )
          }
        />
      )}
      {subtitle && <div>{subtitle}</div>}
      <div data-test-id="page-content">{children}</div>
    </SpacingY>
  )
}
